import { canAccessSecgroup, hasNoSystemAccess } from '../../utils/permissions';
import { EduCapabilities } from './types';
import { canConsultEduAccess, canOpenEduAdministration } from './policies';

export function isEduPath(path: string): boolean { return /^\/?(?:mob\/)?fermi-edu(?:\/|$)/.test(path); }
export function canAccessFermiRoute(role: string | null | undefined, route: { path: string; secgroup: number }, capabilities: EduCapabilities): boolean {
    if (route.secgroup === 85) return route.path.startsWith('fermi-edu/acessos/') ? canConsultEduAccess(capabilities)
        : route.path === 'fermi-edu' && canOpenEduAdministration(capabilities);
    return !hasNoSystemAccess(role) && canAccessSecgroup(role, route.secgroup);
}
